import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import OrionCallCard from '../components/OrionCallCard'

const useStyles = makeStyles(() => ({
  empty: {
    padding: '14px 12px',
    color: 'var(--color-neutral-500)',
    fontSize: 13,
    fontStyle: 'italic',
    border: '1px dashed var(--color-neutral-200)',
    borderRadius: 'var(--border-radius-sm, 4px)'
  },
  skipped: {
    padding: '6px 10px',
    backgroundColor: 'var(--color-neutral-100)',
    color: 'var(--color-neutral-600)',
    fontSize: 11,
    borderRadius: 'var(--border-radius-sm, 4px)'
  }
}))

export default function OrionConnectTab ({ steps, entry }) {
  const classes = useStyles()
  const orionSteps = (steps || []).filter(s => s.$op === 'orion/get-reporting-data')
  const built = orionSteps.filter(s => s.orionConnect && !s.orionConnect.skipped)
  const skipped = orionSteps.filter(s => s.orionConnect?.skipped)

  if (orionSteps.length === 0) {
    return <div className={`${classes.empty} text-center`}>This pipeline has no orion/get-reporting-data steps.</div>
  }

  if (built.length === 0) {
    return (
      <>
        <div className={`${classes.empty} text-center`}>No /Reporting/Scope body could be built — see skipped reasons:</div>
        {skipped.map(step => (
          <div key={step.index} className={`${classes.skipped} font-mono mb-2`}>
            step #{step.index} — reason: {step.orionConnect.reason}
            {step.orionConnect.error ? ` (${step.orionConnect.error})` : ''}
          </div>
        ))}
      </>
    )
  }

  // Show the first built call full-bleed; rare additional / skipped calls
  // surface as small notes pointing at the Steps tab.
  const primary = built[0]
  const others = built.slice(1)

  return (
    <>
      <OrionCallCard step={primary} entry={entry} />
      {others.length > 0 && (
        <div className={`${classes.skipped} font-mono mt-3`}>
          {others.length} additional /Reporting/Scope call{others.length === 1 ? '' : 's'} in this pipeline — see Steps tab for per-call detail.
        </div>
      )}
      {skipped.length > 0 && skipped.map(step => (
        <div key={step.index} className={`${classes.skipped} font-mono mt-3`}>
          step #{step.index} skipped — reason: {step.orionConnect.reason}
        </div>
      ))}
    </>
  )
}

OrionConnectTab.propTypes = {
  steps: PropTypes.array,
  entry: PropTypes.object
}
